import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './ForkPage.css';
import RocketDock from './img/rocket-dock.webp';
import PilotAcademy from './img/pilot-academy.webp';
import ConferenceHall from './img/conference-hall.webp';
import Cargo from './img/cargo.webp';
import Bank from './img/bank.webp';
import CommStation from './img/comm-station.webp';
import CorpHQ from './img/corp-hq.webp';
import LaunchBay from './img/launch-bay.webp';
import RoadOne from './img/road-one.webp';
import RoadTwo from './img/road-two.webp';
import RoadThree from './img/road-three.webp';
import RoadFour from './img/road-four.webp';
import RoadFive from './img/road-five.webp';
import RoadSix from './img/road-six.webp';
import RoadSeven from './img/road-seven.webp';
import React, { useState, useEffect } from 'react';

const roads = [
  RoadOne, RoadTwo, RoadThree, RoadFour, RoadFive, RoadSix, RoadSeven
];

const ForkPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, []);

  return (
    <div className="container">
      {loading ? (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
      ) : (
        <div className="fork-bg">
          <div className="fork-map">
            {roads.map((img, idx) => (
              <img src={img} alt={`Image ${idx+1}`} className="road-item" />
            ))}
          </div>
          <div className="fork-grid">
            <button className="fork-item" onClick={() => navigate('/rocket-dock')}>
              <img src={RocketDock} alt={'Image 1'} />
            </button>
            <button className="fork-item" onClick={() => navigate('/academy')}>
              <img src={PilotAcademy} alt={'Image 2'} />
            </button>
            <button className="fork-item" onClick={() => navigate('/communication')}>
              <img src={CommStation} alt={'Image 3'} />
            </button>
            <button className="fork-item" onClick={() => navigate('/cargo')}>
              <img src={Cargo} alt={'Image 4'} />
            </button>
            <button className="fork-item" onClick={() => navigate('/corporation')}>
              <img src={CorpHQ} alt={'Image 5'} />
            </button>
            <button className="fork-item" onClick={() => navigate('/hall')}>
              <img src={ConferenceHall} alt={'Image 6'} />
            </button>
            <button className="fork-item" onClick={() => navigate('/wallet')}>
              <img src={Bank} alt={'Image 7'} />
            </button>
          </div>
          <div className="fork-footer">
            <button className="fork-item fork-item-footer" onClick={() => navigate('/video')}>
              <img src={LaunchBay} alt='Image 8' />
            </button>
          </div>
          <BackButton onClick={() => navigate(-1)} />
        </div>
      )}
    </div>
  );
};

export default ForkPage;